import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { sweetAlert } from 'src/app/utils/swal';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { downloadBase64File, downloadFile } from '../../../utils/pdf-downloader';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { KpisService } from '../kpis-service/kpis.service';
import { urls } from 'src/app/utils/url-utils';
import { state } from '@angular/animations';
import { CompaniesService } from '../../companies/service/companies.service';
import * as moment from 'moment';
import { AuthService } from 'src/app/service/auth-service/auth.service';
@Component({
  selector: 'app-nemt-statistics',
  templateUrl: './nemt-statistics.component.html',
  styleUrls: ['./nemt-statistics.component.css']
})
export class NemtStatisticsComponent implements OnInit, OnDestroy {

  getKpisState: Observable<any>;
  kpisStats;
  dateForm: FormGroup;
  selectedCompany: any = "";
  selectedCompanyId = "Select Company";
  fundingSources:any;
  companiesList;
  statistics:any;
  companyToken:any;
  startDate = moment().startOf("day").toISOString();
  endDate = moment().endOf("day").toISOString();
  constructor(
    private companyService: CompaniesService,
    private kpisService: KpisService,
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService

  ) {
  }

  ngOnInit() {

    this.dateForm = this.fb.group({
      dateRange: [[this.startDate,this.endDate]]
    });
    this.getCompaniesList();
    // this.getNemtStats();
  }

  getNemtStats() {
    this.kpisService
      .getNemtStatistics()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.kpisStats = data[0];
        }
      })
    // this.store.dispatch(new NemtStatistics());
  }

  getNemtStatsByDateRange() {
   
    const startDate = this.dateForm.value.dateRange[0].startOf('day').toISOString();
    const endDate = this.dateForm.value.dateRange[1].endOf('day').toISOString();
    this.kpisService
      .getNemtStatisticsByDate(startDate, endDate, this.companyToken)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.kpisStats =  data[0];
          this.fundingSources = data[0].cooperates;
          
        }
      })
    // this.store.dispatch(new NemtStatisticsByDateRange(startDate, endDate));
  }

  statDetails(status) {
    if (this.dateForm.value.dateRange[0] && this.dateForm.value.dateRange[1]) {
      // tslint:disable-next-line: max-line-length
      // this.router.navigate(['reports/statisticsdetails'], { state: { status, startDate: this.dateForm.value.dateRange[0].toISOString(),
      //    endDate: this.dateForm.value.dateRange[1].toISOString() } });
         let w = window.open('reports/statisticsdetails');
         w['newData'] = { status, startDate: this.dateForm.value.dateRange[0].startOf('day').toISOString(), endDate: this.dateForm.value.dateRange[1].endOf('day').toISOString() }
    } else {
      sweetAlert('Error', 'Please Select Date Range First.', 'error', 'Ok');
    }
  }

  getStatReport() {
    if (this.dateForm.value.dateRange[0] && this.dateForm.value.dateRange[1]) {
      const data = {
        endDate: this.dateForm.value.dateRange[1].endOf('day').toISOString(),
        startDate: this.dateForm.value.dateRange[0].startOf('day').toISOString()
      };
      this.kpisService
        .getNemtStatisticsReportPdf(data)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(data => {
          if (data) {
            downloadBase64File(data.content, data.pdfName);
          }
        })
      // this.store.dispatch(new NemtStatisticsReportPdf(data));
    }
  }

  kpiTripsReport() {
    const payload = {
      endDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[1].endOf('day').toISOString() : null,
      startDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[0].startOf('day').toISOString() : null,
    };
    // DownloadFile.downloadURI(name, url);

    this.kpisService
      .getNemtStatsTripReportsXls(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          let name = data.excelName;
          let url = urls.REPORT_SERVER_URL + '/excel/' + name;
          downloadFile(url, '', name);
        }
      })
  }
  getCompaniesList() {
    const queryParams = {
      accountStatus: 'active',
      isRemoveIAAL: false
    }

    this.companyService.getCompanies(queryParams)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe((data) => {
      if (data) {
        this.companiesList = data;

      }
    });
  }

  onDropdownChange() {
    // this.selectedCompanyId = evt.target.value;
    this.statistics = null;
    this.selectedCompany = this.companiesList.find((x) => x._id === this.selectedCompanyId);
    this.getCompanyToken();
  }

  getCompanyToken(): any {
    if (!this.selectedCompany) {
      return;
    }
    this.companyService.getCompanyToken(this.selectedCompany._id)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe((data: any) => {
      this.companyToken = data.companyToken;
      if (data && data.companyToken) {
      this.authService.setToken(data.companyToken,'providerToken');
        const newStartDate = moment(this.startDate)
          .tz(this.selectedCompany.timeZone, true)
          .toISOString();
        const newEndDate = moment(this.endDate)
          .tz(this.selectedCompany.timeZone, true)
          .toISOString();

        this.getNEMTStatistics(newStartDate, newEndDate, data.companyToken);
      }
    })

  }


  getNEMTStatistics(startDate, endDate, companyToken) {
    this.kpisService
      .getKpiStatistics(startDate, endDate, companyToken)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data: any) => {
        if (data) {
          console.log('data', data);
          this.kpisStats = data[0];
           this.fundingSources = data[0].cooperates;
           console.log('companies', this.fundingSources);
          

        }
      });
  }


  ngOnDestroy(): void {

  }
}
